import { ValidSpaceNameValidatorDirective } from './src/app/spaces/valid-space-name.directive';
import { ValidSpaceAssignedIdValidatorDirective } from './src/app/spaces/valid-space-assigned-id.directive';
import { UniqueSpaceAssignedIdValidatorDirective } from './src/app/spaces/unique-space-assigned-id.directive';

import { SpaceNamePipe } from './src/app/spaces/space-name.pipe';
import { NgModule } from '@angular/core';


export class OpenfactSyncModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
  ],
  declarations: [
    SpaceNamePipe,
    ValidSpaceNameValidatorDirective,
    ValidSpaceAssignedIdValidatorDirective,
    UniqueSpaceAssignedIdValidatorDirective
  ],
  exports: [
    SpaceNamePipe,
    ValidSpaceNameValidatorDirective,
    ValidSpaceAssignedIdValidatorDirective,
    UniqueSpaceAssignedIdValidatorDirective
  ],
  providers: [
    SpaceNamePipe
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
